import { render, staticRenderFns } from "./BetaFeatures.vue?vue&type=template&id=44f216d0&"
import script from "./BetaFeatures.vue?vue&type=script&lang=ts&"
export * from "./BetaFeatures.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44f216d0')) {
      api.createRecord('44f216d0', component.options)
    } else {
      api.reload('44f216d0', component.options)
    }
    module.hot.accept("./BetaFeatures.vue?vue&type=template&id=44f216d0&", function () {
      api.rerender('44f216d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/misc/BetaFeatures.vue"
export default component.exports